<template>
  <div class="grid grid-cols-1 gap-2">
    <el-card 
      v-for="(item, index) in items" 
      :key="index" 
      class="grid-item hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer"
      @click="handleClick(item.link)"
    >
      <div class="image-container">
        <img :src="item.url" alt="grid image" class="grid-image" />
        <div class="blur-overlay"></div>
      </div>
      <div class="card-overlay">
        <h3>{{ item.title }}</h3>
        <p>{{ item.content }}</p>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    handleClick(link) {
      if (!link) return;

      // 判断是否是外部链接（以 http:// 或 https:// 开头）
      if (link.startsWith('http://') || link.startsWith('https://')) {
        // 跳转到外部网页
        window.location.href = link;
      } else {
        console.log(link);
        // 获取当前点击项的标题
        const title = this.items.find(item => item.link === link)?.title || '';
        // 使用路由跳转到内部页面，携带标题参数
        this.$router.replace({
          path: link,
          query: {
            title: title
          }
        });
      }
    }
  }
}
</script>

<style scoped>
.image-container {
  position: relative;
  overflow: hidden;
}

.grid-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: all 0.3s ease;
}

.blur-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(0);
  background: rgba(255, 255, 255, 0);
  transition: all 0.3s ease;
}

.grid-item:hover .grid-image {
  transform: scale(1.05);
}

.grid-item:hover .blur-overlay {
  
  background: rgba(255, 255, 255, 0.1);
}

.grid-item {
  position: relative;
  border: 1px solid #ddd;
  padding: 0;
  overflow: hidden;
  transition: all 0.3s ease;
  margin-bottom: 16px;

  border-radius: 10px;
  font-family: 'Times New Roman', Times, serif;
}

.card-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 16px;
  transform: translateY(0);
  transition: opacity 0.3s ease;
  opacity: 0.8;
  border-radius: 10px;
  text-align: center;
  font-size: 18rpx;
  font-family: 'Times New Roman', Times, serif;
}

.grid-item:hover .card-overlay {
  opacity: 0.9;
}
</style> 
